export default __webpack_public_path__ + "sounds/notif.mp3";